import React from 'react';
import { Route, Switch } from 'react-router';
import universal from 'react-universal-component';

import { useUpdatePageTitle } from 'Utilities/hooks/useUpdatePageTitle';

import Status404 from '../../error/404';
import { useFetchConfigStateData } from '../Hooks/Adapters/useFetchConfigStateData';
import { useFetchUserStateData } from '../Hooks/Adapters/useFetchUserStateData';
import { useGetRouteAndPageName } from '../Hooks/useGetRouteAndPageName';

import { CheckerProvider } from './CheckerContext';
import { defaultLazyLoadOptions, MOT_RESULT_ROUTE, TAX_RESULT_ROUTE } from './CheckerRouter.utils';

const CheckerPage = universal(() => import('./CheckerPage/CheckerPage'), defaultLazyLoadOptions);
const CheckerResultsPage = universal(() => import('./CheckerResultsPage/CheckerResultsPage'), defaultLazyLoadOptions);

const CheckerRouter = () => {
  const { routeInfo } = useGetRouteAndPageName();

  const { acf, apiError, experimentDecisions } = useFetchConfigStateData({
    wordpressPathname: routeInfo?.route,
  });
  const userDetails = useFetchUserStateData();

  useUpdatePageTitle({ acf, identifier: routeInfo?.checkerPage });

  const initialValue = { acf, apiError, experimentDecisions, user: userDetails };

  return (
    <CheckerProvider value={initialValue}>
      <Switch>
        <Route
          exact
          path={routeInfo?.route}
        >
          <CheckerPage checkerPage={routeInfo?.checkerPage} />
        </Route>
        <Route
          exact
          path={[MOT_RESULT_ROUTE, TAX_RESULT_ROUTE]}>
          <CheckerResultsPage />
        </Route>
        <Route render={() => (<Status404 />)} />
      </Switch>
    </CheckerProvider>
  );
};

export default CheckerRouter;
